import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import AuthContext, { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import DashboardLayout from './pages/DashboardLayout';
import LoginRoute from './components/LoginRoute';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Reset from './pages/Reset';
import SetupAccount from './pages/SetupAccount';
import Account from './pages/Account';
import Dashboard from './pages/Dashboard';
import MySchedule from './pages/MySchedule';
import CreateCompany from './pages/CreateCompany';
import Employees from './pages/Employees';
import CompanySettings from './pages/CompanySettings';
import Planning from './pages/Planning';
import TeamAvailability from './pages/TeamAvailability';
import MyAvailability from './pages/MyAvailability';
import PublicCompanyLogin from './pages/PublicCompanyLogin';
import PublicCompanySchedule from './pages/PublicCompanySchedule';
import NotFound from './pages/NotFound';
import { useContext } from 'react';

const Home = () => {
  const { currentUser, loading } = useContext(AuthContext);
  if (loading) return null; // Attendre que le statut de connexion soit connu
  return currentUser ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#975114ff',
    },
    secondary: {
      main: '#4d9b09ff',
    },
  },
});

const router = createBrowserRouter([
  {
    element: <LoginRoute />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <Signup /> },
      { path: "/reset", element: <Reset /> },
      { path: "/setup-account", element: <SetupAccount /> },
    ],
  },
  {
    element: <PrivateRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          // Routes for all authenticated users
          { path: "/create-company", element: <CreateCompany />, handle: { title: 'Créer une entreprise' } },
          { path: "/dashboard", element: <Dashboard />, handle: { title: 'Tableau de bord' } },
          { path: "/availability", element: <MyAvailability />, handle: { title: 'Mes disponibilités' } },
          { path: "/account", element: <Account />, handle: { title: 'Mon Compte' } },
          { path: "/schedule", element: <MySchedule />, handle: { title: 'Mon horaire' } },
          // Admin-only routes
          { element: <AdminRoute />, children: [
            { path: "/team-availability", element: <TeamAvailability />, handle: { title: 'Dispo. équipe' } },
            { path: "/planning", element: <Planning />, handle: { title: 'Planning du personnel' } },
            { path: "/employees", element: <Employees />, handle: { title: 'Gestion des Employés' } },
            { path: "/company-settings", element: <CompanySettings />, handle: { title: 'Paramètres de l\'entreprise' } },
          ]},
        ],
      },
    ],
  },
  // Routes publiques qui ne doivent pas être affectées par la connexion principale
  { path: "/public/:publicId", element: <PublicCompanyLogin /> },
  { path: "/public/:publicId/schedule", element: <PublicCompanySchedule /> },
  { path: "*", element: <NotFound /> },
]);

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;